import * as yup from "yup";

export const HOUR_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;
export const MAX_DAILY_HOUR_GAP = 10;

export const parseHourToMinutes = (value: string): number => {
    const [h, m] = value.split(":").map(Number);
    return h * 60 + m;
};

export type DailyHoursMessages = {
    required: string;
    invalid: string;
    endAfterStart: string;
    maxGap: string;
};

export const createDailyHoursFields = (messages: DailyHoursMessages) => ({
    dailyStartHour: yup.string().required(messages.required).matches(HOUR_PATTERN, messages.invalid),
    dailyEndHour: yup
        .string()
        .required(messages.required)
        .matches(HOUR_PATTERN, messages.invalid)
        .test("daily-hours-after-start", messages.endAfterStart, function (endValue) {
            const startValue = this.parent.dailyStartHour;
            if (!HOUR_PATTERN.test(startValue ?? "") || !HOUR_PATTERN.test(endValue ?? "")) {
                return true;
            }
            return parseHourToMinutes(endValue) > parseHourToMinutes(startValue);
        })
        .test("daily-hours-max-gap", messages.maxGap, function (endValue) {
            const startValue = this.parent.dailyStartHour;
            if (!HOUR_PATTERN.test(startValue ?? "") || !HOUR_PATTERN.test(endValue ?? "")) {
                return true;
            }
            return parseHourToMinutes(endValue) - parseHourToMinutes(startValue) <= MAX_DAILY_HOUR_GAP * 60;
        }),
});
